
import { TableLink24Filled, TableLink24Regular, bundleIcon } from "@fluentui/react-icons";

export const MergeIcon = bundleIcon(TableLink24Filled, TableLink24Regular);